module.exports = __webpack_public_path__ + "static/media/dark-background.9955cdab.png";